import { createFileRoute } from '@tanstack/react-router'
import { AutomationCreatePage } from '@/pages/automations/automation-create/automation-create-page'
import { WorkspaceEntitlementGate } from '@/features/workspace-entitlements/ui/workspace-entitlement-gate'
import { WorkspaceEntitlementKey } from '@/graphql/schema'

export const Route = createFileRoute('/automations/new')({
  component: () => (
    <WorkspaceEntitlementGate feature={WorkspaceEntitlementKey.Automations}>
      <AutomationCreatePage />
    </WorkspaceEntitlementGate>
  ),
})
